import React, { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { pageRows } from "../../utils/analyticsPages";
import { flooredShare } from "../../utils/analyticsSentences";
import RankedBars from "../charts/RankedBars";
import { LOCALES } from "../charts/format";
import { LoadingOrError } from "./ActivityStates";
import Segmented from "./Segmented";

const LISTS = { start: "analyticsPagesStart", message: "analyticsPagesThrough" };

// A frase de resumo (D8): a parte das conversas que comecou nas paginas da lista de onde comecaram, no
// singular quando a lista tem uma pagina so. So aparece quando ha "Outras paginas" (decisao do Tiago a 28-Out):
// com todas as paginas na lista a frase so repetia as barras. Sem nenhuma pagina na lista (so caminhos
// compridos de mais, que vao para as outras) tambem nao ha frase. A parte vai por defeito e nao arredondada: a
// frase so aparece com "Outras paginas" acima de zero logo por baixo, e nunca pode dizer 100%.
const leadOf = (pages, translate) => {
  const listed = pages.start.pages;
  if (pages.start.others === 0 || listed.length === 0) return null;
  const share = flooredShare(listed.reduce((sum, page) => sum + page.conversations, 0), pages.conversations);
  return listed.length === 1 ? translate("analyticsPagesLeadOne", { share }) : translate("analyticsPagesLead", { share, count: listed.length });
};

// Desde quando ha paginas: comparam-se os instantes (o `data_since` contra o `period.start` da resposta),
// como nos cliques do Assistente, e a data diz-se no fuso do periodo.
const sinceNote = (pages, translate, language) => {
  if (!pages.data_since || new Date(pages.data_since) <= new Date(pages.period.start)) return null;
  const date = new Intl.DateTimeFormat(LOCALES[language] || language, { dateStyle: "medium", timeStyle: "short", timeZone: pages.period.tz }).format(
    new Date(pages.data_since)
  );
  return translate("analyticsPagesSince", { date });
};

// As paginas com mais conversas (D8 do plano das paginas do RPAA-286): onde as conversas comecaram ou por onde
// passaram, com a escolha nas acoes como no `DevicesCard`. O titulo e o nome da lista mostrada, e o ficheiro
// leva tambem o da secao (D10), e uma coluna com a percentagem de cada linha (decisao do Tiago a 28-Out). As
// percentagens sao sempre sobre as conversas do periodo. A frase de resumo fala de onde comecaram e so aparece
// nessa lista; a ressalva de que nao somam 100% so na outra.
const PagesCard = ({ pages, error, onRetry }) => {
  const { translate, language } = useLanguage();
  const [which, setWhich] = useState("start");
  if (!pages) return <LoadingOrError error={error} onRetry={onRetry} />;
  const sectionTitle = translate("analyticsPagesTitle");
  const title = translate(LISTS[which]);
  const info = which === "start" ? translate("analyticsPagesNote") : `${translate("analyticsPagesNote")} ${translate("analyticsPagesThroughNote")}`;
  const choice = (
    <Segmented
      label={sectionTitle}
      options={Object.entries(LISTS).map(([value, label]) => ({ value, label: translate(label) }))}
      value={which}
      onChange={setWhich}
    />
  );
  return (
    <RankedBars
      title={title}
      note={sinceNote(pages, translate, language)}
      lead={which === "start" ? leadOf(pages, translate) : null}
      info={info}
      actions={choice}
      breakdown={{ total: pages.conversations }}
      rows={pageRows(pages, which, translate)}
      downloadName={`${sectionTitle} ${title}`}
      shareColumn={translate("analyticsPagesShareColumn")}
    />
  );
};

export default PagesCard;
